<template>
  <b-sidebar :id="drawerId" title="Sidebar" shadow right v-model="open" bg-variant="white" no-header>
    <template #default="{ hide }">
      <div class="p-3">
        <div class="d-flex align-items-center justify-content-between">
          <div class="drawer-title">Title</div>
          <b-button variant="light" @click="hide">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="#454646"/>
            </svg>
          </b-button>
        </div>
        <slot>

        </slot>
        <b-button variant="primary" block @click="hide">Close Sidebar</b-button>
      </div>
    </template>
    <div class="px-3 py-2">
      <slot>
        <b-button variant="primary" @click="closeDrawer">
          Close Me
        </b-button>
      </slot>
    </div>
  </b-sidebar>
</template>

<script>
  import Swal from "sweetalert2";

  export default {
    nams: "base-drawer",
    data() {
      return {
        open: false,
      }
    },
    computed:{
      drawerId(){
        return this._uid.toString();
      },
    },
    methods: {
      show() {
        this.openDrawer();
      },
      openDrawer(){
        this.open = true;
      },
      closeDrawer() {
        if(this.open) this.$emit('close');

        this.open = false;
      },
      failedAlert(error) {
        return Swal.fire({
          title: this.$t('Failed') + '!',
          text: (error.response && (error.response.data || {}).message) || error.message,
          type: 'danger',
          confirmButtonClass: 'btn btn-danger btn-fill',
          buttonsStyling: false
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .drawer-title {
    color: #0084F3;
    font-size: 16px;
    font-weight: 800;
    line-height: 20px; /* 125% */
    letter-spacing: 0.8px;
  }
</style>